import Vue from 'vue'
import Vuetify from 'vuetify'
import '@/main.styl'
import settings from '@/settings.ts'

Vue.use(Vuetify, settings.vuetifySettings)
